module.exports = __webpack_public_path__ + "static/media/Gotham-Book.6c1e5372.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Book.eot
 ** module id = 1335
 ** module chunks = 0
 **/